<template>
  <div class="loader-container">
    <div v-if="loading" class="loader"></div>
  </div>
</template>

<style scoped>
.loader-container {
  margin-bottom: 16px;
  height: 4px;
}
.loader {
  height: 4px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
}
.loader:before{
  display: block;
  position: absolute;
  content: "";
  left: -200px;
  width: 200px;
  height: 4px;
  background-color: #2980b9;
  animation: loading 2s linear infinite;
}

@keyframes loading {
    from {left: -200px; width: 30%;}
    50% {width: 30%;}
    70% {width: 70%;}
    80% { left: 50%;}
    95% {left: 120%;}
    to {left: 100%;}
}
</style>

<script>
// Reference - https://www.pexels.com/blog/css-only-loaders/
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    loading: 'loading'
  })
}
</script>



// WEBPACK FOOTER //
// LoadingBar.vue?703390eb